/**
 * Entidade Service (Serviço / Registro de serviço).
 * Referencia User e Client.
 */

import { z } from 'zod';
import { UserRef } from '../user/entity';

/** Tipos de serviço no ramo de ar condicionado. 'manutencao' mantido para retrocompat. */
export const serviceTypeSchema = z.enum([
  'instalacao',
  'limpeza',
  'manutencao',
  'manutencao_preventiva',
  'manutencao_corretiva',
  'recarga_gas',
  'troca_filtro',
  'higienizacao',
  'outro',
]);
export type ServiceType = z.infer<typeof serviceTypeSchema>;

/** Labels para exibição. Centralizado para uso em listas e formulários. */
export const SERVICE_TYPE_LABELS: Record<ServiceType, string> = {
  instalacao: 'Instalação',
  limpeza: 'Limpeza',
  manutencao: 'Manutenção',
  manutencao_preventiva: 'Manutenção preventiva',
  manutencao_corretiva: 'Manutenção corretiva',
  recarga_gas: 'Recarga de gás',
  troca_filtro: 'Troca de filtro',
  higienizacao: 'Higienização',
  outro: 'Outro',
};

export const serviceSchema = z.object({
  id: z.string().min(1),
  user_id: z.string().min(1),
  client_id: z.string().min(1),
  type: serviceTypeSchema,
  /** Quando type === 'outro', descrição livre do serviço. */
  type_other_description: z.string().nullable().optional().default(null),
  service_date: z.string(),
  next_maintenance_months: z.number().int().min(0),
  next_maintenance_date: z.string(),
  equipment_reference: z.string().nullable(),
  value: z.number().nullable(),
  notes: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Service = z.infer<typeof serviceSchema>;

/** Referências Firestore da entidade Service (paths e strings centralizadas). */
export class ServiceRef {
  static readonly collection = 'services';
  static collectionPath(userId: string): string {
    const userPath = UserRef.docPath(userId);
    return `${userPath}/${this.collection}`;
  }
  static docPath(userId: string, id: string): string {
    const collectionPath = this.collectionPath(userId);
    return `${collectionPath}/${id}`;
  }
}
